import html from '../assets/svg/skills/html.svg'
import css from '../assets/svg/skills/css.svg'
import javascript from '../assets/svg/skills/javascript.svg'
import java from '../assets/svg/skills/java.svg'
import python from '../assets/svg/skills/python.svg'
import angular from '../assets/svg/skills/angular.svg'
import react from '../assets/svg/skills/react.svg'
import nextJS from '../assets/svg/skills/nextJS.svg'
import typescript from '../assets/svg/skills/typescript.svg'
import bootstrap from '../assets/svg/skills/bootstrap.svg'
import tailwind from '../assets/svg/skills/tailwind.svg'
import mongoDB from '../assets/svg/skills/mongoDB.svg'
import mysql from '../assets/svg/skills/mysql.svg'
import django from '../assets/svg/skills/django.svg'
import aws from '../assets/svg/skills/aws.svg'
import figma from '../assets/svg/skills/figma.svg'
import docker from '../assets/svg/skills/docker.svg'
import git from '../assets/svg/skills/git.svg'
import numpy from '../assets/svg/skills/numpy.svg'
import vitejs from '../assets/svg/skills/vitejs.svg'
import materialui from '../assets/svg/skills/materialui.svg'
import nodejs from '../assets/svg/skills/nodejs.svg' 
import pandas from '../assets/svg/skills/pandas.svg' 
import DA from '../assets/svg/skills/DA.svg'

export const skillsImage = (skill) => {
    const skillID = skill.toLowerCase();

    switch (skillID) {
        case 'html':
            return html;
        case 'css':
            return css;
        case 'javascript':
            return javascript;
        case 'java':
            return java;
        case 'python':
            return python;
        case 'node js':
            return nodejs; 
        case 'figma':
            return figma;
        case 'react':
            return react;
        case 'angular':
            return angular;
        case 'bootstrap':
            return bootstrap;
        case 'tailwind':
            return tailwind;
        case 'mongodb':
            return mongoDB;
        case 'mysql':
            return mysql;
        case 'materialui':
            return materialui;
        case 'django':
            return django;
        case 'aws':
            return aws;
        case 'next js':
            return nextJS;
        case 'git':
            return git;
        case 'numpy':
            return numpy;
        case 'pandas':
            return pandas;
        case 'docker':
            return docker;
        case 'typescript':
            return typescript;
        case 'vitejs':
            return vitejs;
        case 'data analytics':
            return DA;

        
        default:
            return null;
    }
}
